import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxNavigationWithDataComponent } from 'ngx-navigation-with-data';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.sass']
})
export class ErrorPageComponent implements OnInit {
  public status:string = "";
  public message:string = "";

  constructor(public navCtrl: NgxNavigationWithDataComponent) {
    this.status = this.navCtrl.get('status') ?? "404";
    switch (this.status){
      case "204":
        this.message = "Valor no encontrado, la información que esta buscando no existe!"
        break
      case "404":
        this.message = "Pagina en desarrollo!";
        break
    }
   }

  ngOnInit(): void {}

}
